var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.292V15.007C9 13.3501 10.3431 12.007 12 12.007C13.6569 12.007 15 13.3501 15 15.007V15.292",
    stroke: "#A9A7BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.252 5.25696L12.002 12.007",
    stroke: "#A9A7BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37695 7.50696C6.16985 7.50696 6.00195 7.67485 6.00195 7.88196C6.00195 8.08906 6.16985 8.25696 6.37695 8.25696C6.58406 8.25696 6.75195 8.08906 6.75195 7.88196C6.75195 7.67485 6.58406 7.50696 6.37695 7.50696V7.50696",
    stroke: "#A9A7BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.127 11.257C18.9198 11.257 18.752 11.4249 18.752 11.632C18.752 11.8391 18.9198 12.007 19.127 12.007C19.3341 12.007 19.502 11.8391 19.502 11.632C19.502 11.4249 19.3341 11.257 19.127 11.257V11.257",
    stroke: "#A9A7BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.627 7.50696C17.4752 7.50615 17.3378 7.597 17.2791 7.73707C17.2205 7.87713 17.252 8.03875 17.3591 8.14641C17.4662 8.25408 17.6277 8.28653 17.7681 8.22861C17.9084 8.17068 18 8.03382 18 7.88196C18 7.67486 17.8321 7.50696 17.625 7.50696V7.50696",
    stroke: "#A9A7BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37695 4.50696C9.16985 4.50696 9.00195 4.67485 9.00195 4.88196C9.00195 5.08906 9.16985 5.25696 9.37695 5.25696C9.58406 5.25696 9.75195 5.08906 9.75195 4.88196C9.75195 4.67485 9.58406 4.50696 9.37695 4.50696V4.50696",
    stroke: "#A9A7BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.431 18.142C15.8384 13.9619 8.16155 13.9619 2.56897 18.142",
    stroke: "#A9A7BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.257C18.2132 23.257 23.25 18.2202 23.25 12.007C23.25 5.79375 18.2132 0.756958 12 0.756958C5.7868 0.756958 0.75 5.79375 0.75 12.007C0.75 18.2202 5.7868 23.257 12 23.257Z",
    stroke: "#A9A7BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87695 11.257C4.66985 11.257 4.50195 11.4249 4.50195 11.632C4.50195 11.8391 4.66985 12.007 4.87695 12.007C5.08406 12.007 5.25195 11.8391 5.25195 11.632C5.25195 11.4249 5.08406 11.257 4.87695 11.257",
    stroke: "#A9A7BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.161a090eb3258193c24fa58b5e52690b.svg";
export { ForwardRef as ReactComponent };